import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { NAV } from './Header';
import { EASE_CSS } from '../../motion/tokens';

// Full-screen overlay nav for < lg. Links stagger in; body scroll locks.
export default function MobileNav({ open, onClose, isAuthenticated }) {
  useEffect(() => {
    document.documentElement.style.overflow = open ? 'hidden' : '';
    return () => {
      document.documentElement.style.overflow = '';
    };
  }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  const items = [...NAV, { to: isAuthenticated ? '/hub' : '/login', label: isAuthenticated ? 'Hub' : 'Sign in' }];

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          className="fixed inset-0 z-[70] flex flex-col bg-ink px-6 pb-8 pt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          role="dialog"
          aria-modal="true"
          aria-label="Menu"
        >
          <div className="flex h-12 items-center justify-between">
            <span className="font-display text-xl font-semibold">Blu<span className="text-sky">prise</span></span>
            <button type="button" onClick={onClose} className="flex h-11 w-11 items-center justify-center rounded-full border border-line" aria-label="Close menu">
              <X className="h-5 w-5" />
            </button>
          </div>
          <nav className="mt-10 flex flex-1 flex-col gap-1" aria-label="Primary">
            {items.map((item, i) => (
              <motion.div
                key={item.to}
                initial={{ y: 24, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.05 + i * 0.05, duration: 0.6, ease: EASE_CSS }}
              >
                <Link to={item.to} onClick={onClose} className="block py-3 font-display text-4xl font-normal tracking-tight text-cream">
                  {item.label}
                </Link>
              </motion.div>
            ))}
          </nav>
          <Link to="/contact" onClick={onClose} className="flex h-14 items-center justify-center rounded-full bg-cream text-base font-medium text-ink">
            Start a project
          </Link>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
